import React from 'react';
import loadable from '@loadable/component'
import useSsr from './useSsr'

const IndexComponent = loadable(() => {
  return import ('./IndexComponent')
})
const GazeteComponent = loadable(() => {
  return import ('./GazeteComponent')
})
const YearPageComponent = loadable(() => {
  return import ('./YearPageComponent')
})
const GazeteSayisi = loadable(() => import ('./GazeteSayisi'))
const GazeteSayfasi = loadable(() => import ('./GazeteSayfasi'))
const KupurPageComponent = loadable(() => import ('./KupurPageComponent'))
const AraPageComponent = loadable(() => import ('./AraPageComponent'))
const BlockAraPage = loadable(() => import ('./pages/BlockAraPage'))
const TarihComponent = loadable(() => {
  return import ('./TarihComponent')}
)
const PrivacyPage = loadable(() => {
  return import ('./PrivacyPage')
})
const CollectionPage = loadable(() => import ('./pages/Collection'))
const EtiketPage = loadable(() => import ('./pages/Etiket'))
const KupurKesPageComponent = loadable(() => import ('./KupurKesPageComponent'))
const KupurOnerPage = loadable(() => import ('./KupurOnerPage'))
const AccountPage = loadable(() => import ('./AccountPage'))
const ResetPasswordPage = loadable(() => import('./pages/ResetPasswordPage'))

const NotFound = () => {
  console.debug("[NotFound route] Route not found");
  
  const {context: ssrContext} = useSsr()

  if (ssrContext) {
    ssrContext.status = 404
  }

  return <h1>Oops, nothing here!</h1>;
}

const Routes = [
  {
    path: '/',
    exact: true,
    component: IndexComponent,
  },
  {
    path: "/gazete/:gazete/:tarih/:sayfa",
    component: GazeteSayfasi,
  },
  {
    path: '/gazete/:gazete/:page?',
    component: GazeteComponent,
  },
  {
    path: '/gazeteSayisi/:gazete/:tarih',
    component: GazeteSayisi,
  },
  {
    path: '/kupurKes/:gazete/:tarih/:sayfa',
    component: KupurKesPageComponent
  },
  {
    path: '/kupurOner/:gazete?/:tarih?/:sayfa?',
    component: KupurOnerPage
  },
  {
    path: '/kupur/:id',
    component: KupurPageComponent,
  },
  {
    path: '/ara/:query?/:page?',
    component: AraPageComponent,
  },
  {
    path: '/blockAra/:query?/:page?',
    component: BlockAraPage,
  },
  {
    path: '/etiket/:etiket?/:page?',
    component: EtiketPage,
  },
  { 
    path: '/tarih/:tarih',
    component: TarihComponent,
  },
  {
    path: '/yil/:yil',
    component: YearPageComponent,
  },
  {
    path: '/collection/:id',
    component: CollectionPage
  },
  {
    path: '/account',
    component: AccountPage,
  },
  {
    path: "/privacy",
    component: PrivacyPage
  },
  {
    path: "/subscription",
    component: loadable(() => import('./pages/SubscriptionPage'))
  },
  {
    path: '/reset-password',
    component: ResetPasswordPage,
    exact: true
  },
  {
    component: NotFound
  }
]

export default Routes;
